
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/theatres",
      function () {
        return require("private-next-pages/theatres/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/theatres"])
      });
    }
  